import React, { useState, useEffect } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import './EasterEgg.css';

const KONAMI = ['ArrowUp', 'ArrowUp', 'ArrowDown', 'ArrowDown', 'ArrowLeft', 'ArrowRight', 'ArrowLeft', 'ArrowRight', 'b', 'a'];

export default function EasterEgg() {
  const [keys, setKeys] = useState([]);
  const [activated, setActivated] = useState(false);

  useEffect(() => {
    const handleKey = (e) => {
      setKeys(prev => {
        const updated = [...prev, e.key].slice(-10);
        if (updated.length === 10 && updated.every((k, i) => k === KONAMI[i])) {
          setActivated(true);
          setTimeout(() => setActivated(false), 5000);
        }
        return updated;
      });
    };

    window.addEventListener('keydown', handleKey);
    return () => window.removeEventListener('keydown', handleKey);
  }, []);

  return (
    <AnimatePresence>
      {activated && (
        <motion.div
          className="easter-overlay"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
        >
          <motion.div
            className="easter-content"
            initial={{ scale: 0, rotate: -180 }}
            animate={{ scale: 1, rotate: 0 }}
            exit={{ scale: 0, rotate: 180 }}
            transition={{ type: 'spring', stiffness: 200 }}
          >
            <div className="easter-emoji">🪶✨</div>
            <h2 className="easter-title">Tu as trouvé le secret !</h2>
            <p className="easter-text">Plumly a été créé par Lucas, un créateur extraordinaire qui est parti de zéro pour construire cette plateforme incroyable avec 90+ fonctionnalités.</p>
            <p className="easter-text">Si tu lis ceci, sache que tout est possible. Il suffit de commencer. 💪</p>
            <div className="easter-plumes">
              {Array.from({ length: 12 }, (_, i) => (
                <motion.span
                  key={i}
                  className="easter-plume"
                  animate={{
                    y: [0, -100 - Math.random() * 200],
                    x: (Math.random() - 0.5) * 200,
                    opacity: [1, 0],
                    rotate: Math.random() * 360,
                  }}
                  transition={{ duration: 2 + Math.random() * 2, repeat: Infinity, repeatDelay: Math.random() * 2 }}
                >
                  🪶
                </motion.span>
              ))}
            </div>
          </motion.div>
        </motion.div>
      )}
    </AnimatePresence>
  );
}